import React, { useEffect } from "react";
import moment from "moment";
import { Moment } from "moment";
import { Box } from "@mui/material";

import { DATE_FORMAT } from "../../../../constants";
import { StyledDatePicker } from "../../../../components/ui";
import { TRenderDay } from "../../../../components/ui/StyledDatePicker";

interface IProps {
  customPeriodStart: string;
  customPeriodEnd: string;
  setCustomPeriodStart: (a: string) => void;
  setCustomPeriodEnd: (a: string) => void;
  isActive: boolean;
  autoOk?: boolean;
  renderDay?: TRenderDay;
}

const SelectCustomPeriod = ({
  customPeriodStart,
  customPeriodEnd,
  setCustomPeriodStart,
  setCustomPeriodEnd,
  isActive,
  ...rest
}: IProps): React.ReactElement => {
  const handleChangeCustomPeriodStart = (date: Moment | null) => {
    if (!date) {
      setCustomPeriodStart("");
      return;
    }
    if (date.isValid()) {
      setCustomPeriodStart(date.format(DATE_FORMAT));
    }
  };

  const handleChangeCustomPeriodEnd = (date: Moment | null) => {
    if (!date) {
      setCustomPeriodEnd("");
      return;
    }
    if (date.isValid()) {
      setCustomPeriodEnd(date.format(DATE_FORMAT));
    }
  };

  useEffect(() => {
    if (isActive) {
      handleChangeCustomPeriodStart(null);
      handleChangeCustomPeriodStart(null);
    }
  }, [isActive]);

  return (
    <Box sx={{ marginLeft: "10px", display: "flex", flexDirection: "row", gap: "10px" }}>
      <StyledDatePicker
        label="Begin"
        name="Begin"
        value={(customPeriodStart as unknown as Moment) || null}
        onChange={handleChangeCustomPeriodStart}
        maxDate={moment()}
        {...rest}
      />
      <StyledDatePicker
        disabled={!customPeriodStart}
        label="End"
        name="End"
        value={(customPeriodEnd as unknown as Moment) || null}
        minDate={moment(customPeriodStart)}
        maxDate={moment()}
        onChange={handleChangeCustomPeriodEnd}
        {...rest}
      />
    </Box>
  );
};

export default SelectCustomPeriod;
